import { OtherDetails } from "../../model/Incident/OtherDetails";
import { Case } from "../../api/models/Case";
import { IncidentUtils } from "../IncidentUtils";
import { AppointmentUtils } from "../AppointmentUtils";
import { Appointment } from "../../model/Appointment";
import { PersonalDetailsUtils } from "../PersonalDetailsUtils";
import { PersonDetail } from "../../model/PersonDetail";
import { ImmobilizationType } from "../../model/ImmobilizationType.enum";
import { HighwayUtils } from "../HighwayUtils";
import { LocationUtils } from "../LocationUtils";

export class OtherUtils {
  public static serialize(
    data: OtherDetails,
    appointment: Appointment | undefined,
    personDetail: PersonDetail,
    immobilizationType: ImmobilizationType,
    immobilizedOnHighway: boolean | undefined
  ): Partial<Case> {
    return {
      MainCause: "12",
      Comment: this.getCaseComment(
        data.description,
        personDetail,
        immobilizedOnHighway,
        immobilizationType
      ),
      Priority: HighwayUtils.serializePriority(
        immobilizationType,
        AppointmentUtils.getPriority(appointment)
      ),
      ItemsUsedList: [
        {
          ...IncidentUtils.getItemType(),
          Description: data.description,
          LastVehicleStatus: {
            PrimaryFault: "65076",
            Comment: `Zusätzliche Informationen; ${data.description}`,
          },
        },
      ],
    };
  }

  public static getSummary(data: OtherDetails): string {
    return data.description;
  }

  private static getCaseComment(
    description: string,
    data: PersonDetail,
    immobilizedOnHighway: boolean | undefined,
    immobilizationType: ImmobilizationType
  ): string {
    const extra = description ? "S. Kommentar Pannenart" : undefined;

    return [
      LocationUtils.getCaseComment(immobilizedOnHighway, immobilizationType),
      extra,
      PersonalDetailsUtils.serializeCaseComment(data),
      ...PersonalDetailsUtils.serializeCoverageComment(data),
    ]
      .filter(Boolean)
      .join("; ");
  }
}
